import React from 'react';

export const name = 'flag-LI';

export const FlagLI = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_2_283)">
      <mask
        id="mask0_2_283"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <path d="M24 0H0V24H24V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_2_283)">
        <path
          d="M24 12C24 15.1826 22.7357 18.2349 20.4853 20.4853C18.2348 22.7357 15.1826 24 12 24C8.81742 24 5.76516 22.7357 3.51472 20.4853C1.26428 18.2349 0 15.1826 0 12C0.520313 12 12 10.4344 12 10.4344L24 12Z"
          fill="#D80027"
        />
        <path
          d="M0 12C0 8.81742 1.26428 5.76516 3.51472 3.51472C5.76516 1.26428 8.81742 0 12 0C15.1826 0 18.2348 1.26428 20.4853 3.51472C22.7357 5.76516 24 8.81742 24 12"
          fill="#0052B4"
        />
        <path
          d="M8.86876 8.34371C8.86735 8.04245 8.77909 7.74798 8.61451 7.49565C8.44993 7.24332 8.21602 7.04382 7.94091 6.9211C7.66576 6.79839 7.36107 6.75765 7.06337 6.80378C6.76566 6.84995 6.4876 6.98096 6.26251 7.18121V6.26246H6.78282V5.21715H6.26251V4.69684H5.2172V5.21715H4.69688V6.26246H5.2172V7.18121C4.90613 6.91478 4.50309 6.78081 4.09443 6.80804C3.68578 6.83532 3.30408 7.0216 3.03118 7.32704C2.75828 7.63243 2.61592 8.0326 2.63463 8.44173C2.65334 8.85085 2.83162 9.2364 3.13125 9.51559V10.4343H8.34376V9.51559C8.66251 9.22965 8.86407 8.81246 8.86407 8.34371H8.86876Z"
          fill="#FFDA44"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_2_283">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
